import {
  GET_QUOTATION_FAIL,
  GET_QUOTATION_SUCCESS,
  GET_QUOTATIONS_FAIL,
  GET_QUOTATIONS_SUCCESS,
  ADD_QUOTATION_SUCCESS,
  ADD_QUOTATION_FAIL,
  UPDATE_QUOTATION_SUCCESS,
  UPDATE_QUOTATION_FAIL,
  DELETE_QUOTATION_SUCCESS,
  DELETE_QUOTATION_FAIL,  
  SET_STATE_QUOTATION
} from "./actionTypes";

const INIT_STATE = {
  quotations: [],
  quotation: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const quotations = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_QUOTATIONS_SUCCESS:
      return {
        ...state,
        quotations: action.payload.quotations,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_QUOTATION:
      return { ...state, loading: action.payload }

    case GET_QUOTATIONS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_QUOTATION_SUCCESS:
      return {
        ...state,
        quotations: [...state.quotations, action.payload],
      };

    case ADD_QUOTATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_QUOTATION_SUCCESS:
      return {
        ...state,
        quotations: state.quotations.map(quotation =>
          quotation.id.toString() === action.payload.id.toString()
            ? { ...action.payload, quotation }
            : quotation
        ),
      };

    case UPDATE_QUOTATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_QUOTATION_SUCCESS:
      return {
        ...state,
        quotations: state.quotations.filter(
          quotation => quotation.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_QUOTATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_QUOTATION_SUCCESS:
      return {
        ...state,
        quotation: action.payload,
      };

    case GET_QUOTATION_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default quotations;
